var exports = {
  "z": "anchorWrapper__Shhtjx",
  "P": "label__4pC8-d",
};

module.exports = exports;
